import React, { useState, useEffect } from 'react'; // Adjust the path as needed
import { getPTimez, getTimez, timezones } from '../hooks/timeUtilities';

function TimeZoneDisplay() {
  const [allTimezones, setAllTimezones] = useState([]);
  const [localTime, setLocalTime] = useState('');
  const [selectedTimeZone, setSelectedTimeZone] = useState('');
  const [selectedTime, setSelectedTime] = useState('');

  useEffect(() => {
    // Fetch and set the available time zones and local time on load
    setAllTimezones(timezones());
    setLocalTime(getTimez());
  }, []);

  const handleTimeZoneChange = (e) => {
    const timezone = e.target.value;
    setSelectedTimeZone(timezone);
    setSelectedTime(getPTimez(timezone));
  };

  return (
    <div>
      <h1>Time Zone Display</h1>
      <p>Local Time: {localTime}</p>

      <label htmlFor="timezone">Select Time Zone:</label>
      <select id="timezone" onChange={handleTimeZoneChange} value={selectedTimeZone}>
        <option value="">--Select a Time Zone--</option>
        {allTimezones.map((zone, index) => (
          <option key={index} value={zone}>{zone}</option>
        ))}
      </select>

      {selectedTimeZone && (
        <div>
          <p>Selected Time Zone: {selectedTimeZone}</p>
          <p>Current Time: {selectedTime}</p>
        </div>
      )}
    </div>
  );
}

export default TimeZoneDisplay;
